var OCS = OCS || {};
OCS.Advisories = OCS.Advisories || {};
OCS.Advisories.Config = {
    "AFA":{
        "id": "AFA",
        "name": "Ashfall Watch",
        "zindex": "880",
        "color": "#adadadFF"
    },
    "AFW":{
        "id": "AFW",
        "name": "Ashfall Warning",
        "zindex": "400",
        "color": "#adadadFF"
    },
    "AFY":{
        "id": "AFY",
        "name": "Ashfall Advisory",
        "zindex": "1230",
        "color": "#adadadFF"
    },
    "AQY":{
        "id": "AQY",
        "name": "Air Quality Alert",
        "zindex": "9000",
        "color": "#808080FF"
    },
    "ASA":{
        "id": "ASA",
        "name": "Air Stagnation Watch",
        "zindex": "840",
        "color": "#808080FF"
    },
    "ASW":{
        "id": "ASW",
        "name": "Air Stagnation Warning",
        "zindex": "360",
        "color": "#808080FF"
    },
    "ASY":{
        "id": "ASY",
        "name": "Air Stagnation Advisory",
        "zindex": "1110",
        "color": "#808080FF"
    },
    "BHS":{
        "id": "BHS",
        "name": "Beach Hazards Statement",
        "zindex": "9000",
        "color": "#40E0D0FF"
    },
    "BSA":{
        "id": "BSA",
        "name": "Blowing Snow Watch",
        "zindex": "680",
        "color": "#ADD8E6FF"
    },
    "BSW":{
        "id": "BSW",
        "name": "Blowing Snow Warning",
        "zindex": "190",
        "color": "#ADD8E6FF"
    },
    "BSY":{
        "id": "BSY",
        "name": "Blowing Snow Advisory",
        "zindex": "1010",
        "color": "#ADD8E6FF"
    },
    "BWA":{
        "id": "BWA",
        "name": "Brisk Wind Watch",
        "zindex": "810",
        "color": "#D8BFD8FF"
    },
    "BWW":{
        "id": "BWW",
        "name": "Brisk Wind Warning",
        "zindex": "350",
        "color": "#D8BFD8FF"
    },
    "BWY":{
        "id": "BWY",
        "name": "Brisk Wind Advisory",
        "zindex": "1100",
        "color": "#D8BFD8FF"
    },
    "BZA":{
        "id": "BZA",
        "name": "Blizzard Watch",
        "zindex": "660",
        "color": "#ADFF2FFF"
    },
    "BZW":{
        "id": "BZW",
        "name": "Blizzard Warning",
        "zindex": "180",
        "color": "#FF4500FF"
    },
    "BZY":{
        "id": "BZY",
        "name": "Blizzard Advisory",
        "zindex": "1020",
        "color": "#ADFF2FFF"
    },
    "CFA":{
        "id": "CFA",
        "name": "Coastal Flood Watch",
        "zindex": "750",
        "color": "#66CDAAFF"
    },
    "CFW":{
        "id": "CFW",
        "name": "Coastal Flood Warning",
        "zindex": "240",
        "color": "#228B22FF"
    },
    "CFY":{
        "id": "CFY",
        "name": "Coastal Flood Advisory",
        "zindex": "530",
        "color": "#7CFC00FF"
    },
    "CFS":{
        "id": "CFS",
        "name": "Coastal Flood Statement",
        "zindex": "1370",
        "color": "#6B8E23FF"
    },
    "FGA":{
        "id": "FGA",
        "name": "Dense Fog Watch",
        "zindex": "870",
        "color": "#708090FF"
    },
    "FGW":{
        "id": "FGW",
        "name": "Dense Fog Warning",
        "zindex": "390",
        "color": "#708090FF"
    },
    "FGY":{
        "id": "FGY",
        "name": "Dense Fog Advisory",
        "zindex": "1190",
        "color": "#708090FF"
    },
    "MFY":{
        "id": "MFY",
        "name": "Marine Dense Fog Advisory",
        "zindex": "1200",
        "color": "#708090FF"
    },
    "DSA":{
        "id": "DSA",
        "name": "Dust Storm Watch",
        "zindex": "860",
        "color": "#ffe6c5FF"
    },
    "DSW":{
        "id": "DSW",
        "name": "Dust Storm Warning",
        "zindex": "370",
        "color": "#FFE4C4FF"
    },
    "DSY":{
        "id": "DSY",
        "name": "Dust Storm Advisory",
        "zindex": "1240",
        "color": "#ffe6c5FF"
    },
    "DUA":{
        "id": "DUA",
        "name": "Blowing Dust Watch",
        "zindex": "830",
        "color": "#BDB76BFF"
    },
    "DUW":{
        "id": "DUW",
        "name": "Blowing Dust Warning",
        "zindex": "380",
        "color": "#BDB76BFF"
    },
    "DUY":{
        "id": "DUY",
        "name": "Blowing Dust Advisory",
        "zindex": "1250",
        "color": "#BDB76BFF"
    },
    "ECA":{
        "id": "ECA",
        "name": "Extreme Cold Watch",
        "zindex": "710",
        "color": "#0000ffFF"
    },
    "ECW":{
        "id": "ECW",
        "name": "Extreme Cold Warning",
        "zindex": "210",
        "color": "#0000FFFF"
    },
    "ECY":{
        "id": "ECY",
        "name": "Extreme Cold Advisory",
        "zindex": "950",
        "color": "#0000FFFF"
    },
    "EHA":{
        "id": "EHA",
        "name": "Excessive Heat Watch",
        "zindex": "760",
        "color": "#800000FF"
    },
    "EHW":{
        "id": "EHW",
        "name": "Excessive Heat Warning",
        "zindex": "290",
        "color": "#C71585FF"
    },
    "EHY":{
        "id": "EHY",
        "name": "Excessive Heat Advisory",
        "zindex": "1120",
        "color": "#800000FF"
    },
    "EWA":{
        "id": "EWA",
        "name": "Extreme Wind Watch",
        "zindex": "800",
        "color": "#ff1094FF"
    },
    "EWW":{
        "id": "EWW",
        "name": "Extreme Wind Warning",
        "zindex": "310",
        "color": "#FF1493FF"
    },
    "EWY":{
        "id": "EWY",
        "name": "Extreme Wind Advisory",
        "zindex": "1040",
        "color": "#ff1094FF"
    },
    "FAA":{
        "id": "FAA",
        "name": "Areal Flood Watch",
        "zindex": "570",
        "color": "#2E8B57FF"
    },
    "FAW":{
        "id": "FAW",
        "name": "Areal Flood Warning",
        "zindex": "130",
        "color": "#00ff7bFF"
    },
    "FAY":{
        "id": "FAY",
        "name": "Areal Flood Advisory",
        "zindex": "540",
        "color": "#00ff7bFF"
    },
    "FFA":{
        "id": "FFA",
        "name": "Flash Flood Watch",
        "zindex": "550",
        "color": "#32CD32FF"
    },
    "FFW":{
        "id": "FFW",
        "type": "FFW",
        "name": "Flash Flood Warning",
        "zindex": "120",
        "color": "#00FF00FF"
    },
    "FFY":{
        "id": "FFY",
        "name": "Flash Flood Advisory",
        "zindex": "560",
        "color": "#31ce31FF"
    },
    "FFS":{
        "id": "FFS",
        "name": "Flash Flood Statement",
        "zindex": "1350",
        "color": "#9ACD32FF"
    },
    "FLA":{
        "id": "FLA",
        "name": "Flood Watch",
        "zindex": "580",
        "color": "#2E8B57FF"
    },
    "FLW":{
        "id": "FLW",
        "name": "Flood Warning",
        "zindex": "100",
        "color": "#00FF00FF"
    },
    "FLY":{
        "id": "FLY",
        "name": "Flood Advisory",
        "zindex": "520",
        "color": "#00FF7FFF"
    },
    "FLS":{
        "id": "FLS",
        "name": "Flood Statement",
        "zindex": "1360",
        "color": "#00ff00FF"
    },
    "FRA":{
        "id": "FRA",
        "name": "Frost Watch",
        "zindex": "630",
        "color": "#6495EDFF"
    },
    "FRW":{
        "id": "FRW",
        "name": "Frost Warning",
        "zindex": "140",
        "color": "#6495EDFF"
    },
    "FRY":{
        "id": "FRY",
        "name": "Frost Advisory",
        "zindex": "890",
        "color": "#6495EDFF"
    },
    "FWA":{
        "id": "FWA",
        "name": "Fire Weather Watch",
        "zindex": "85",
        "color": "#FFDEADFF"
    },
    "FWW":{
        "id": "FWW",
        "name": "Red Flag Warning",
        "zindex": "410",
        "color": "#FF1493FF"
    },
    "FWY":{
        "id": "FWY",
        "name": "Fire Weather Advisory",
        "zindex": "1220",
        "color": "#ffdeadFF"
    },
    "FZA":{
        "id": "FZA",
        "name": "Freeze Watch",
        "zindex": "650",
        "color": "#4169E1FF"
    },
    "FZW":{
        "id": "FZW",
        "name": "Freeze Warning",
        "zindex": "160",
        "color": "#00FFFFFF"
    },
    "FZY":{
        "id": "FZY",
        "name": "Freeze Advisory",
        "zindex": "900",
        "color": "#4169e1FF"
    },
    "GLA":{
        "id": "GLA",
        "name": "Gale Watch",
        "zindex": "820",
        "color": "#DDA0DDFF"
    },
    "GLW":{
        "id": "GLW",
        "name": "Gale Warning",
        "zindex": "340",
        "color": "#DDA0DDFF"
    },
    "GLY":{
        "id": "GLY",
        "name": "Gale Advisory",
        "zindex": "1260",
        "color": "#DDA0DDFF"
    },
    "HFA":{
        "id": "HFA",
        "name": "Hurricane Force Wind Watch",
        "zindex": "790",
        "color": "#ce5a5aFF"
    },
    "HFW":{
        "id": "HFW",
        "name": "Hurricane Force Wind Warning",
        "zindex": "330",
        "color": "#CD5C5CFF"
    },
    "HFY":{
        "id": "HFY",
        "name": "Hurricane Force Wind Advisory",
        "zindex": "1030",
        "color": "#ce5a5aFF"
    },
    "HIA":{
        "id": "HIA",
        "name": "Inland Hurricane Watch",
        "zindex": "500",
        "color": "#FFA07AFF"
    },
    "HIW":{
        "id": "HIW",
        "name": "Inland Hurricane Warning",
        "zindex": "60",
        "color": "#CD5C5CFF"
    },
    "HIY":{
        "id": "HIY",
        "name": "Inland Hurricane Advisory",
        "zindex": "1180",
        "color": "#ffa57bFF"
    },
    "HSA":{
        "id": "HSA",
        "name": "Heavy Snow Watch",
        "zindex": "670",
        "color": "#8c29e6FF"
    },
    "HSW":{
        "id": "HSW",
        "name": "Heavy Snow Warning",
        "zindex": "170",
        "color": "#8A2BE2FF"
    },
    "HSY":{
        "id": "HSY",
        "name": "Heavy Snow Advisory",
        "zindex": "960",
        "color": "#8c29e6FF"
    },
    "HTA":{
        "id": "HTA",
        "name": "Heat Watch",
        "zindex": "770",
        "color": "#ff7b52FF"
    },
    "HTW":{
        "id": "HTW",
        "name": "Heat Warning",
        "zindex": "300",
        "color": "#ff7b52FF"
    },
    "HTY":{
        "id": "HTY",
        "name": "Heat Advisory",
        "zindex": "1130",
        "color": "#ff7b52FF"
    },
    "HUA":{
        "id": "HUA",
        "name": "Hurricane Watch",
        "zindex": "490",
        "color": "#FF00FFFF"
    },
    "HUW":{
        "id": "HUW",
        "name": "Hurricane Warning",
        "zindex": "50",
        "color": "#DC143CFF"
    },
    "HUY":{
        "id": "HUY",
        "name": "Hurricane Advisory",
        "zindex": "1160",
        "color": "#9370DBFF"
    },
    "HUS":{
        "id": "HUS",
        "name": "Hurricane Statement",
        "zindex": "1380",
        "color": "#9370DBFF"
    },
    "HWA":{
        "id": "HWA",
        "name": "High Wind Watch",
        "zindex": "780",
        "color": "#B8860BFF"
    },
    "HWW":{
        "id": "HWW",
        "name": "High Wind Warning",
        "zindex": "320",
        "color": "#DAA520FF"
    },
    "HWY":{
        "id": "HWY",
        "name": "High Wind Advisory",
        "zindex": "1050",
        "color": "#bd8408FF"
    },
    "HYA":{
        "id": "HYA",
        "name": "Hydrologic Watch",
        "zindex": "610",
        "color": "#00ff7bFF"
    },
    "HYW":{
        "id": "HYW",
        "name": "Hydrologic Warning",
        "zindex": "420",
        "color": "#00ff7bFF"
    },
    "HYY":{
        "id": "HYY",
        "name": "Hydrologic Advisory",
        "zindex": "1270",
        "color": "#00ff7bFF"
    },
    "HZW":{
        "id": "HZW",
        "name": "Hard Freeze Warning",
        "zindex": "280",
        "color": "#0000FFFF"
    },
    "HZA":{
        "id": "HZA",
        "name": "Hard Freeze Watch",
        "zindex": "640",
        "color": "#4169E1FF"
    },
    "IPW":{
        "id": "IPW",
        "name": "Sleet Warning",
        "zindex": "230",
        "color": "#87CEEBFF"
    },
    "IPA":{
        "id": "IPA",
        "name": "Sleet Watch",
        "zindex": "730",
        "color": "#84ceefFF"
    },
    "IPY":{
        "id": "IPY",
        "name": "Sleet Advisory",
        "zindex": "1210",
        "color": "#7B68EEFF"
    },
    "ISW":{
        "id": "ISW",
        "name": "Ice Storm Warning",
        "zindex": "220",
        "color": "#8B008BFF"
    },
    "LBY":{
        "id": "LBY",
        "name": "Lake Effect Snow and Blowing Snow Advisory",
        "zindex": "980",
        "color": "#48D1CCFF"
    },
    "LEA":{
        "id": "LEA",
        "name": "Lake Effect Snow Watch",
        "zindex": "690",
        "color": "#87CDFAFF"
    },
    "LEW":{
        "id": "LEW",
        "name": "Lake Effect Snow Warning",
        "zindex": "200",
        "color": "#008B8BFF"
    },
    "LEY":{
        "id": "LEY",
        "name": "Lake Effect Snow Advisory",
        "zindex": "990",
        "color": "#48D1CCFF"
    },
    "UPW":{
        "id": "UPW",
        "name": "Heavy Freezing Spray Warning",
        "zindex": "250",
        "color": "#00BFFFFF"
    },
    "UPA":{
        "id": "UPA",
        "name": "Heavy Freezing Spray Watch",
        "zindex": "930",
        "color": "#BC8F8FFF"
    },
    "UPY":{
        "id": "UPY",
        "name": "Heavy Freezing Spray Advisory",
        "zindex": "1170",
        "color": "#BC8F8FFF"
    },
    "LOA":{
        "id": "LOA",
        "name": "Low Water Watch",
        "zindex": "620",
        "color": "#A52A2AFF"
    },
    "LOY":{
        "id": "LOY",
        "name": "Low Water Advisory",
        "zindex": "1280",
        "color": "#A52A2AFF"
    },
    "LSA":{
        "id": "LSA",
        "name": "Lakeshore Flood Watch",
        "zindex": "590",
        "color": "#66CDAAFF"
    },
    "LSW":{
        "id": "LSW",
        "name": "Lakeshore Flood Warning",
        "zindex": "110",
        "color": "#228B22FF"
    },
    "LSY":{
        "id": "LSY",
        "name": "Lakeshore Flood Advisory",
        "zindex": "600",
        "color": "#7CFC00FF"
    },
    "LSS":{
        "id": "LSS",
        "name": "Lakeshore Flood Statement",
        "zindex": "1390",
        "color": "6B8E23FF"
    },
    "LWY":{
        "id": "LWY",
        "name": "Lake Wind Advisory",
        "zindex": "1080",
        "color": "#D2B48CFF"
    },
    "MAS":{
        "id": "MAS",
        "name": "Marine Statement",
        "zindex": "1400",
        "color": "#FFDAB9FF"
    },
    "RBY":{
        "id": "RBY",
        "name": "Small Craft for Rough Bar Advisory",
        "zindex": "1290",
        "color": "#D8BFD8FF"
    },
    "RPS":{
        "id": "RPS",
        "name": "High Rip Current Risk",
        "zindex": "1290",
        "color": "#D8BFD8FF"
    },
    "SBY":{
        "id": "SBY",
        "name": "Snow and Blowing Snow Advisory",
        "zindex": "1000",
        "color": "#B0E0E6FF"
    },
    "SNY":{
        "id": "SNY",
        "name": "Snow Advisory",
        "zindex": "970",
        "color": "#6699CCFF"
    },
    "SCY":{
        "id": "SCY",
        "name": "Small Craft Advisory",
        "zindex": "1300",
        "color": "#D8BFD8FF"
    },
    "SIY":{
        "id": "SIY",
        "name": "Small Craft for Winds Advisory",
        "zindex": "1310",
        "color": "#D8BFD8FF"
    },
    "SWY":{
        "id": "SWY",
        "name": "Small Craft for Hazardous Seas Advisory",
        "zindex": "1330",
        "color": "#D8BFD8FF"
    },
    "SEA":{
        "id": "SEA",
        "name": "Hazardous Seas Watch",
        "zindex": "9000",
        "color": "#483D8BFF"
    },
    "SEW":{
        "id": "SEW",
        "name": "Hazardous Seas Warning",
        "zindex": "260",
        "color": "#DDA0DDFF"
    },
    "SMY":{
        "id": "SMY",
        "name": "Dense Smoke Advisory",
        "zindex": "1320",
        "color": "#F0E68CFF"
    },
    "SRA":{
        "id": "SRA",
        "name": "Storm Watch",
        "zindex": "9000",
        "color": "#EE82EEFF"
    },
    "SRW":{
        "id": "SRW",
        "name": "Storm Warning",
        "zindex": "80",
        "color": "#9400D3FF"
    },
    "SUW":{
        "id": "SUW",
        "name": "High Surf Warning",
        "zindex": "270",
        "color": "#228B22FF"
    },
    "SUY":{
        "id": "SUY",
        "name": "High Surf Advisory",
        "zindex": "1070",
        "color": "#BA55D3FF"
    },
    "SVA":{
        "id": "SVA",
        "name": "Severe T-Storm Watch",
        "zindex": "46",
        "color": "#DB7093FF"
    },
    "SVW":{
        "id": "SVW",
        "type": "SVR",
        "name": "Severe T-Storm Warning",
        "zindex": "20",
        "color": "#FFA500FF"
    },
    "SVS":{
        "id": "SVS",
        "name": "Severe T-Storm Statement",
        "zindex": "1340",
        "color": "#00ffffFF"
    },
    "MAW":{
        "id": "MAW",
        "name": "Special Marine Warning",
        "zindex": "440",
        "color": "#FFA500FF"
    },
    "TOA":{
        "id": "TOA",
        "name": "Tornado Watch",
        "zindex": "450",
        "color": "#FFFF00FF"
    },
    "TOW":{
        "id": "TOW",
        "type": "TOR",
        "name": "Tornado Warning",
        "zindex": "10",
        "color": "#FF0000FF"
    },
    "TIA":{
        "id": "TIA",
        "name": "Inland Tropical Storm Watch",
        "zindex": "510",
        "color": "#b52121FF"
    },
    "TIW":{
        "id": "TIW",
        "name": "Inland Tropical Storm Warning",
        "zindex": "70",
        "color": "#f78484FF"
    },
    "TRA":{
        "id": "TRA",
        "name": "Tropical Storm Watch",
        "zindex": "470",
        "color": "#F08080FF"
    },
    "TRW":{
        "id": "TRW",
        "name": "Tropical Storm Warning",
        "zindex": "30",
        "color": "#B22222FF"
    },
    "TSA":{
        "id": "TSA",
        "name": "Tsunami Watch",
        "zindex": "740",
        "color": "#D2691EFF"
    },
    "TSW":{
        "id": "TSW",
        "name": "Tsunami Warning",
        "zindex": "90",
        "color": "#FD6347FF"
    },
    "TSY":{
        "id": "TSY",
        "name": "Tsunami Advisory",
        "zindex": "1140",
        "color": "#D2691EFF"
    },
    "TYA":{
        "id": "TYA",
        "name": "Typhoon Watch",
        "zindex": "480",
        "color": "#FF00FFFF"
    },
    "TYW":{
        "id": "TYW",
        "name": "Typhoon Warning",
        "zindex": "40",
        "color": "#DC143CFF"
    },
    "TYY":{
        "id": "TYY",
        "name": "Typhoon Advisory",
        "zindex": "1150",
        "color": "#9370DBFF"
    },
    "WCA":{
        "id": "WCA",
        "name": "Wind Chill Watch",
        "zindex": "720",
        "color": "#5F9EA0FF"
    },
    "WCW":{
        "id": "WCW",
        "name": "Wind Chill Warning",
        "zindex": "430",
        "color": "#5a9ca5FF"
    },
    "WCY":{
        "id": "WCY",
        "name": "Wind Chill Advisory",
        "zindex": "1060",
        "color": "#adefefFF"
    },
    "WIY":{
        "id": "WIY",
        "name": "Wind Advisory",
        "zindex": "1090",
        "color": "#d6b58cFF"
    },
    "WSA":{
        "id": "WSA",
        "name": "Winter Storm Watch",
        "zindex": "700",
        "color": "#4682B4FF"
    },
    "WSW":{
        "id": "WSW",
        "name": "Winter Storm Warning",
        "zindex": "150",
        "color": "#FF69B4FF"
    },
    "WWY":{
        "id": "WWY",
        "name": "Winter Weather Advisory",
        "zindex": "940",
        "color": "#7B68EEFF"
    },
    "ZFY":{
        "id": "ZFY",
        "name": "Freezing Fog Advisory",
        "zindex": "910",
        "color": "#008484FF"
    },
    "ZRY":{
        "id": "ZRY",
        "name": "Freezing Rain Advisory",
        "zindex": "920",
        "color": "#6b5aceFF"
    }
};
try {
    if (typeof (module) !== 'undefined') {
        module.exports = OCS.Advisories.Config;
    }
} catch(e) {
    
}